import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import RadioGroup from '../Radio/RadioGroup';
import RadioWithImage from './RadioWithImage';

const radioCards = [
  {
    imageRef: 'rollover-central.png',
    cardTitle: 'Rollover using RolloverCentral',
    id: 'rollover-central',
  },
  {
    imageRef: 'rollover-directly-to-me.png',
    cardTitle: 'Rollover Directly to Me',
    id: 'rollover-directly-to-me',
  },
  {
    imageRef: 'payment-in-cash.png',
    cardTitle: 'Payment in Cash Directly to Me',
    id: 'payment-in-cash-directly-to-me',
  },
];

function RadioWithImageDemo() {
  const [value, setValue] = useState<string | number>('');

  const handleChange = (e: string | number) => {
    setValue(e);
  };

  return (
    <Container>
      <h4 className={'mb-10'}>Radio With Image</h4>
      <RadioGroup name={'no-labels'} value={value} onChange={handleChange}>
        <Row d-flex flex-column flex-lg-row>
          {radioCards.map((radioCard, idx) => {
            return (
              <Col className={'col-12 col-lg-4 mb-10'}>
                <RadioWithImage
                  key={idx}
                  cardData={radioCard}
                  selected={value !== radioCard.id}
                />
              </Col>
            );
          })}
          <Col className={'col-12 col-lg-4 mb-10'}>
            <RadioWithImage
              cardData={radioCards[0]}
              variant="transperant"
              selected={value !== radioCards[0].id}
            />
          </Col>
        </Row>
      </RadioGroup>
    </Container>
  );
}

export default RadioWithImageDemo;
